import * as React from "react";
import toastr from 'toastr';
import ('jQuery-QueryBuilder');
import 'jQuery-QueryBuilder/dist/css/query-builder.dark.css';
import Utils from "../../Utils";

interface Props {
    initializeRef(el: any): void;
    attributes: any[];
    operators: any[];
    currentRules?: any;
}

interface State {
}

class QueryBuilder extends React.Component<Props, State> {
    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if ((this.props.attributes && this.props.attributes !== prevProps.attributes) || this.props.operators !== prevProps.operators) {
            if (this.props.attributes.length > 0) {
                this.initializeQueryBuilder();
            }
        }
    }

    componentWillUnmount() {
        // @ts-ignore
        $(this.refs.queryBuilder).queryBuilder('destroy');
    }

    initializeQueryBuilder = () => {
        if ($(this.refs.queryBuilder)) {
            // @ts-ignore
            $(this.refs.queryBuilder).queryBuilder('destroy');
        }
        const filters = [];
        const operators = [];
        this.props.operators.forEach(operator => {
            switch(operator.name) {
                case 'exist':
                case 'does_not_exist':
                    operators.push({
                        type: operator.name,
                        // @ts-ignore
                        nb_inputs: 0,
                        apply_to: ['string']
                    });
                    break;
                case 'equal':
                case 'not_equal':
                case 'greater':
                case 'greater_or_equal':
                case 'less':
                case 'less_or_equal':
                    operators.push({
                        type: operator.name,
                        // @ts-ignore
                        nb_inputs: 1,
                        apply_to: ['string']
                    });
                    break;
                case 'contains':
                case 'does_not_contain':
                case 'in':
                case 'not_in':
                    operators.push({
                        type: operator.name,
                        // @ts-ignore
                        nb_inputs: 1,
                        apply_to: ['string'],
                        multiple: true
                    });
                    break;
                default: operators.push({
                    type: operator.name
                });
            }
        })

        this.props.attributes.forEach(attribute => {
            const filterOperators = [];
            this.props.operators.forEach(operator => {
                const foundType = operator.bocoreTypes.map(type => {
                    return type.toLowerCase().replace('_', ' ');
                }).find(type => {
                    return type === attribute.atrbType
                })

                if (foundType) {
                    filterOperators.push(operator.name);
                }
            })

            let filterObj: any = {
                id: attribute.id,
                field: attribute.attrKey,
                label: attribute.name,
                type: 'string',
            };
            if (attribute.atrbType === 'value list') {
                filterObj = {
                    ...filterObj,
                    input: 'select',
                    multiple: true,
                    values: attribute.attributeValues.map(av => {
                        return {
                            value: av.name,
                            label: av.name
                        }
                    }),
                    plugin: 'select2',
                }
            }
            if (filterOperators.length > 0) {
                filterObj['operators'] = filterOperators;
            }

            filters.push(filterObj)
        })

        const element = this.refs.queryBuilder;
        // @ts-ignore
        $(element).queryBuilder({filters, operators});

        if (this.props.currentRules) {
            try {
                // @ts-ignore
                $(element).queryBuilder('setRules', JSON.parse(this.props.currentRules));
            } catch (error) {
                toastr.error(error.message);
            }
        }

        const addClickListener = (element) => {
            if (document.getElementById(element.id).tagName.toLowerCase() === 'div') {
                element.addEventListener('click', () => {
                    Utils.$('#select2-drop').addClass('select2-drop-custom-light');
                    Utils.$('.select2-results').addClass('select2-results-custom-light');
                });
            }
        }
        let s2ids = document.querySelectorAll('[id ^= "s2id_"]');
        Array.prototype.forEach.call(s2ids, addClickListener);

        this.props.initializeRef(element);
    }

    render() {
        return (
            <div ref='queryBuilder'/>
        );
    }
}

export default QueryBuilder



// WEBPACK FOOTER //
// ./app/views/bo-core/QueryBuilder.tsx